// extracted by mini-css-extract-plugin
export default {"eventNameFont":"IIlVMJ","eventNameColor":"JZs4MW"};